import { useEffect } from "react";
import Elmahio from "elmah.io.javascript";
import { useDueDatesAuth } from "../hooks/useDueDatesAuth";

export const useElmahIo = () => {
  const { UserId, TenantId } = useDueDatesAuth();

  useEffect(() => {
    if (!import.meta.env.DEV) {
      const elmah = new Elmahio({
        apiKey: import.meta.env.PUBLIC_ELMAH_API_KEY,
        logId: import.meta.env.PUBLIC_ELMAH_LOG_ID,
        application: "ET.DueDates.WebApp",
        breadcrumbs: true,
        captureConsoleMinimumLevel: "error"
      });

      elmah.on("message", (msg) => {
        if (!msg.data) msg.data = [];
        msg.data.push({ key: "TenantId", value: TenantId });
        msg.data.push({ key: "UserId", value: UserId });
      });

      return () => {
        elmah.dispose?.();
      };
    }
  }, [UserId, TenantId]);
};
